import Vue from 'vue'
import Keyboard from './keyboard'
import Shortcut from './shortcut'
import Global from './global'
import Directives from '@/directives'
import * as Renderer from '@/utils/ipcRenderer'
import SentrySDK from '@/utils/sentry'
import { storeState } from '@/mixins/store'
import { CloseToRefreshList, GlobalPermissionMixin, AdaptLocaleStyle } from '@/mixins'
Vue.use(Global)
Vue.use(Directives)
Vue.use(Keyboard)
Vue.use(Shortcut)
Vue.use(SentrySDK, { Renderer })
Vue.mixin(storeState)
Vue.mixin(CloseToRefreshList)
Vue.mixin(GlobalPermissionMixin)
Vue.mixin(AdaptLocaleStyle)
